<div class="modal-header">
  <h5 class="modal-title">Schedule Details</h5>

  <button
    type="button"
    class="btn-close"
    aria-label="Close"
    (click)="modal.dismiss();"
  ></button>
</div>

<div class="modal-body">
  <div class="details-grid">
    <div class="details-item">
      <span>Schedule ID</span>
      <strong>{{ row.scheduleId }}</strong>
    </div>

    <div class="details-item">
      <span>Source / Job ID</span>
      <strong><a (click)="navigateToCloneHistoryDetails()">{{ row.source }}</a></strong>
    </div>

    <div class="details-item">
      <span>Project Name</span>
      <strong>{{ row.projectName }}</strong>
    </div>

    <div class="details-item">
      <span>Client Name</span>
      <strong>{{ row.clientName }}</strong>
    </div>

    <div class="details-item">
      <span>Item Category</span>
      <strong>{{ row.itemCategory }}</strong>
    </div>

    <div class="details-item">
      <span>Item ID</span>
      <strong>{{ row.itemId }}</strong>
    </div>

    <div class="details-item">
      <span>Status</span>
      <strong>
        <span [class]="getStatusClass(row.status)">
          {{ row.status }}
        </span>
      </strong>
    </div>

    <div class="details-item">
      <span>Scheduled For</span>
      <strong>{{ formatDateTime(row.scheduledFor) }}</strong>
    </div>
  </div>
</div>

<div class="modal-footer">
  @if (row.status?.toLowerCase() === 'scheduled'){
    <button
      type="button"
      class="btn btn-success"
      (click)="reschedule()"
    >
      Reschedule
    </button>
    <button
      type="button"
      class="btn btn-danger"
      (click)="cancel()"
    >
      Cancel Schedule
    </button>
  }

  <button
    type="button"
    class="btn btn-outline-secondary"
    (click)="modal.dismiss();"
  >
    Close
  </button>
</div>